"use client";
import { useState } from "react";
import { useTheme } from "next-themes";

const FAQPage = () => {
	const { theme } = useTheme();
	const [openIndex, setOpenIndex] = useState(null);
	type FAQ = {
		question: string;
		answer: string;
	};


	const faqData:FAQ[] = [
		{
			question:"I am unable to pair Spanda with my mobile phone",
			answer:"If you're unable to pair your Spanda stethoscope with your mobile phone, please ensure the following:\n1. The Spanda stethoscope is powered on.\n2. The Spanda app has the necessary Bluetooth and location permissions.\n3. Your mobile phone and the Spanda stethoscope are within close proximity to each other.\n4. Bluetooth and location services are enabled on your mobile phone."
		},
		{
			question: "How long does a fully charged battery last?",
			answer:
				"A fully charged battery provides over 8 hours of continuous usage. In real-life scenarios, it can last approximately a week, depending on the frequency and type of usage.\nTo conserve battery life, Spanda automatically enters sleep mode after 5 minutes of inactivity.",
		},
		{
			question: "How can I use Spanda with headphones or an external speaker?",
			answer:
				"To use Spanda with headphones or an external speaker, follow these steps:\n1. Ensure the Spanda App is running on your cellphone and paired with the Spanda stethoscope.\n2. Pair your cellphone (already connected to Spanda) with the headphones or external speaker you want to use.\n3. Open the Spanda App and navigate to the Home page.\n4. Tap the headset icon and enable the external headset or speaker option.\nOnce enabled, you’ll be able to hear the sounds through the connected headphones or speaker.",
		},
		{
			question:
				"While using external headset or speaker, can I detach the binaural?",
			answer: "Yes, you can detach your binaural. We recommend using the external screw-on cap to cover the hole for the binaural on the stethoscope, if one was provided with your product. This will ensure protection when the binaural is not in use.",
		},
		{
			question:
				"What type of speakers or headphones should I use with Spanda?",
			answer:
				"Auscultation frequencies are very low, typically ranging from 20 Hz to 1200 Hz. To ensure optimal sound quality, use high-quality speakers or headphones capable of accurately reproducing low frequencies down to 20 Hz.\n\nFor the best experience:\n1. Choose devices from reputed brands with strong low-frequency performance.\n2. If available, enable the Extra Bass setting to further enhance audio clarity",
		},
		{
			question:
				"Why do I sometimes hear an echo when using external speakers during live auscultation?",
			answer:
				"Echo can occur if the external speaker is too close to the auscultation point. The sound from the speaker may re-enter the stethoscope, causing feedback. To prevent this, ensure that the speaker is placed a few meters away from the auscultation area.",
		},
		{
			question: "Do I need a subscription for live streaming?",
			answer:
				"Yes, a subscription is required for live streaming, as it involves the use of dedicated hardware infrastructure and associated service fees.",
		},
		{
			question: "Can Spanda be used on animals?",
			answer:
				"Yes, Spanda is safe and suitable for use by veterinary professionals for animal auscultation. We recommend using Veterinary variant of Spanda Elite or Pro",
		},
		{
			question: "Can I replace the Eartips and Membrane of Spanda?",
			answer:"Yes, the eartips and membrane of Spanda can be replaced. Please refer to section XXX in the Spanda User Guide for detailed instructions"
		},
		{
			question:"How do I upgrade the Spanda software for the device and app?",
			answer:"Spanda features a built-in \"Over The Air\" (OTA) upgrade system:\n1. Ensure your mobile device is connected to the internet and has the Spanda App running. The app will automatically update itself when a new version is available.\n2. When Spanda is connected to the app navigate to the Software Version section in the Settings tab and click on Check for updates.\n3. Incase there is a new update available the app will begin updating the software. \n No manual intervention is needed for updates"
		}
	];

	const handleToggle = (index) => {
		setOpenIndex(openIndex === index ? null : index);
	};

	return (
		<div className="wow fadeInUp relative z-10 bg-transparent p-8 shadow-three dark:bg-darkblue sm:p-11 lg:p-8 xl:p-11">
			{faqData.map((faq, index) => (
				<div key={index} className="mb-6 rounded border border-gray-300 p-4">
					<div
						className="mb-2 cursor-pointer text-left text-xl font-medium flex items-center"
						onClick={() => handleToggle(index)}
					>
						<span style={{ marginRight: '8px' }}>
							{openIndex === index ? '▲' : '▼'}
						</span>
						{faq.question}
					</div>
					{openIndex === index && (
						<div style={{ color: "#000000", whiteSpace: "pre-line" }}>{faq.answer}</div>
					)}
				</div>
			))}
		</div>
	);
};

export default FAQPage;
